import { useCallback } from "react";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useCampaignName = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
